import { Button, Group, Stack, Title } from '@mantine/core';
import { useMemo } from 'react';

import { ProvidedDocuments } from '@e-origin/shared';

import { Table } from '@components';
import { useSendNoDocumentsNotification } from '@hooks/declaration';
import { declarationModalManager } from '../../../declarationModalManager';
import { useControlProvidedDocumentsColumns } from './useControlProvidedDocumentsColumns';

interface ControlProvidedDocumentsProps {
  declarationId: string;
  providedDocuments: ProvidedDocuments[];
}

export const ControlProvidedDocuments = ({ declarationId, providedDocuments = [] }: ControlProvidedDocumentsProps) => {
  const sendNoDocumentsNotification = useSendNoDocumentsNotification();
  const columns = useControlProvidedDocumentsColumns({ declarationId });

  const documentsWithoutResponse = useMemo(() => providedDocuments.filter((doc) => !doc.responseDate), [providedDocuments]);

  const openConfirmSendProvidedDocuments = () => {
    declarationModalManager.openConfirmSendProvidedDocuments(documentsWithoutResponse, declarationId);
  };

  const openConfirmSendWithoutProvidedDocuments = () => {
    declarationModalManager.openConfirmSendWithoutProvidedDocuments(() => {
      sendNoDocumentsNotification.mutate({ declarationId });
    });
  };

  return (
    <Stack ml={20}>
      <Group justify="space-between">
        <Title size="md">Provided documents</Title>
        <Group>
          <Button size="sm" variant="outline" onClick={() => declarationModalManager.openAddProvidedDocument(declarationId)}>
            + Add
          </Button>
          <Button size="sm" onClick={openConfirmSendWithoutProvidedDocuments} disabled={documentsWithoutResponse.length > 0}>
            Notify customs
          </Button>
          <Button size="sm" onClick={openConfirmSendProvidedDocuments} disabled={!documentsWithoutResponse.length}>
            Send
          </Button>
        </Group>
      </Group>
      <Table dataSource={providedDocuments} columns={columns} pagination={false} />
    </Stack>
  );
};
